module.exports = __webpack_public_path__ + "static/media/add_lightbox.a3b5a30e.svg";